module.exports = __webpack_public_path__ + "assets/img/1208.92387284.png";